import BankOutlined from '@ant-design/icons/BankOutlined'
import CloseOutlined from '@ant-design/icons/CloseOutlined'
import { Button, Empty, message, Modal, Popconfirm, Select, Tag } from 'antd'
import { inject, observer } from 'mobx-react'
import React, { memo, useCallback, useEffect, useMemo, useState } from 'react'
import { ASSIGNEE_TYPE } from '../../constants'
import { AvatarHasName } from '../Common/Avatar'
import EmptyContent from '../EmptyContent'
import SpinnerInlineComponent from '../SpinnerInlineComponent/SpinnerInlineComponent'
import SelectUserDepartmentBox from './SelectUserDepartmentBox'

export const isIgnoreSelect = (ignoreSelect, item) => {
  if (!(ignoreSelect?.length > 0)) return false
  if (!item) return false
  const code = (item.code || item.id || item.department_code || '')
    .trim()
    .toUpperCase()
  return ignoreSelect?.includes(code)
}

const { Option } = Select

const defaultKeys = Array.from(Array(100).keys())

const SelectPeoplePopup = props => {
  const {
    id,
    isVisibleSelectPeoplePopup,
    handleSubmitSelectUser,
    handleCancelSelectUser,
    selectPeopleStore,
    authenticationStore,
    companyStore,
    onlyOneUser,
    onlySelectOne,
    disableSelectDepartment,
    noLoadSelectData,
    title,
    okText,
    cancelText,
    isOpenCollapse,
    allowChangeCompany,
    handleUpdateEmpty = () => {},
    isUserDisableList = true,
    setCheckSelectOne,
    checkSelectOne,
    departmentType,
    ignoreSelectList = [],
    ignorePopupType = '',
  } = props

  const {
    selectPopupName,
    companyCode,
    assigneePopupType,
    selectUserData,
    setSelectUserData,
    selectDepartmentData,
    setSelectDepartmentData,
    setDepartmentWithUserList,
    originDepartmentWithUserList,
  } = selectPeopleStore

  const [selectedList, setSelectedList] = useState([])
  const [userDisableList, setUserDisableList] = useState([])
  const [departmentDisableList, setDepartmentDisableList] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [prevUserList, setPrevUserList] = useState([])
  const [prevDepartmentList, setPrevDepartmentList] = useState([])
  const [defaultActiveKey, setDefaultActiveKey] = useState(defaultKeys)

  const { companyList } = companyStore
  const showDropdownCompany = allowChangeCompany ?? true

  useEffect(() => {
    if (!assigneePopupType) return
    setPrevUserList(selectUserData[assigneePopupType])
    setPrevDepartmentList(selectDepartmentData[assigneePopupType])
  }, [isVisibleSelectPeoplePopup])

  useEffect(() => {
    if (noLoadSelectData) return
    ;(async () => {
      if (companyCode) {
        try {
          setIsLoading(true)
          await selectPeopleStore.getDepartmentWithUsers()
        } catch (err) {
          console.log(err)
          message.error(err.vi || 'Đã có lỗi xảy ra!')
        } finally {
          setIsLoading(false)
        }
      }
    })()
  }, [companyCode])

  useEffect(() => {
    if (authenticationStore.currentUser) {
      selectPeopleStore.companyCode = authenticationStore.currentCompanyCode()
    }
  }, [authenticationStore.currentUser])

  useEffect(() => {
    if (!assigneePopupType) return
    const selectedUserList = [
      ...(selectUserData[ASSIGNEE_TYPE.LEADER] || []),
      ...(selectUserData[ASSIGNEE_TYPE.HANDLER] || []),
      ...(selectUserData[ASSIGNEE_TYPE.COMBINER] || []),
      ...(selectUserData[ASSIGNEE_TYPE.FOLLOWER] || []),
      ...(selectUserData[ASSIGNEE_TYPE.UNIT_LEADER] || []),
      ...(selectUserData[ASSIGNEE_TYPE.KT_KTNB] || []),
      ...(selectUserData[ASSIGNEE_TYPE.HDQT] || []),
      ...(selectUserData[ASSIGNEE_TYPE.lanh_dao_vimc] || []),
      ...(selectUserData[ASSIGNEE_TYPE.ban_kt_ktnb] || []),
      ...(selectUserData[ASSIGNEE_TYPE.ban_pc_qtrr_ban_kt_ktnb_vimc] || []),
      ...(selectUserData[ASSIGNEE_TYPE.nddpv_vimc] || []),
      ...(selectUserData[ASSIGNEE_TYPE.dvpt_vimc] || []),
      ...(selectUserData[ASSIGNEE_TYPE.dv_cqvp_vimc] || []),
      ...(selectUserData[ASSIGNEE_TYPE.ban_dieu_hanh_hdqt_vimc] || []),
      ...(selectUserData[ASSIGNEE_TYPE.CREATE]
        ? selectUserData[ASSIGNEE_TYPE.CREATE]
        : []),
      ...(selectUserData[ASSIGNEE_TYPE.tgd_ptgd] || []),
      ...(selectUserData[ASSIGNEE_TYPE.ban_kt_ktnb_vimc] || []),
      ...(selectUserData[ASSIGNEE_TYPE.hdqt_vimc] || []),
      ...(selectUserData[ASSIGNEE_TYPE.ban_dieu_hanh] || []),
      ...(selectUserData[ASSIGNEE_TYPE.truong_ban_bao_cao_rui_ro] || []),
      // ...(selectUserData[ASSIGNEE_TYPE.lanh_dao_ban] || []),
    ]

    const selectedDepartmentList = [
      ...selectDepartmentData[ASSIGNEE_TYPE.LEADER],
      ...selectDepartmentData[ASSIGNEE_TYPE.HANDLER],
      ...selectDepartmentData[ASSIGNEE_TYPE.COMBINER],
      ...selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER],
      ...(selectDepartmentData[ASSIGNEE_TYPE.UNIT_LEADER] || []),
      ...(selectDepartmentData[ASSIGNEE_TYPE.KT_KTNB] || []),
      ...(selectDepartmentData[ASSIGNEE_TYPE.HDQT] || []),
      ...(selectUserData[ASSIGNEE_TYPE.lanh_dao_vimc] || []),
      ...(selectUserData[ASSIGNEE_TYPE.CREATE]
        ? selectDepartmentData[ASSIGNEE_TYPE.CREATE]
        : []),
    ]
    isUserDisableList &&
      setUserDisableList(
        selectedUserList
          .filter(
            el =>
              el.permission !== assigneePopupType &&
              el.permission !== ASSIGNEE_TYPE.lanh_dao_vimc &&
              el.permission !== ASSIGNEE_TYPE.ban_kt_ktnb &&
              el.permission !== ASSIGNEE_TYPE.ban_pc_qtrr_ban_kt_ktnb_vimc &&
              el.permission !== ASSIGNEE_TYPE.nddpv_vimc &&
              el.permission !== ASSIGNEE_TYPE.dvpt_vimc &&
              el.permission !== ASSIGNEE_TYPE.dv_cqvp_vimc &&
              el.permission !== ASSIGNEE_TYPE.ban_dieu_hanh_hdqt_vimc &&
              el.permission !== ASSIGNEE_TYPE.tgd_ptgd &&
              el.permission !== ASSIGNEE_TYPE.ban_kt_ktnb_vimc &&
              el.permission !== ASSIGNEE_TYPE.ban_dieu_hanh &&
              el.permission !== ASSIGNEE_TYPE.lanh_dao_vimc &&
              el.permission !== ASSIGNEE_TYPE.lanh_dao_ban
          )
          .map(el => el.id)
      )
    setDepartmentDisableList(
      selectedDepartmentList
        .filter(el => el.permission !== assigneePopupType)
        .map(el => el.id)
    )
  }, [assigneePopupType])

  useEffect(() => {
    if (!assigneePopupType) return
    setSelectedList([
      ...selectUserData[assigneePopupType],
      ...selectDepartmentData[assigneePopupType],
    ])
  }, [selectUserData, selectDepartmentData, assigneePopupType])

  useEffect(() => {
    setDepartmentWithUserList(originDepartmentWithUserList)
  }, [isVisibleSelectPeoplePopup])

  const handleRemoveSelect = useCallback(
    item => {
      if (!assigneePopupType) return
      if (
        ignoreSelectList.length > 0 &&
        isIgnoreSelect(ignoreSelectList, item)
      ) {
        return
      }
      setSelectUserData({
        ...selectUserData,
        [assigneePopupType]: selectUserData[assigneePopupType].filter(
          el => el.id !== item.id
        ),
      })
      setSelectDepartmentData({
        ...selectDepartmentData,
        [assigneePopupType]: selectDepartmentData[assigneePopupType].filter(
          el => el.id !== item.id
        ),
      })
    },
    [
      assigneePopupType,
      selectUserData,
      selectDepartmentData,
      setSelectUserData,
      setSelectDepartmentData,
      ignoreSelectList,
    ]
  )

  const onCompanyChange = useCallback(
    value => {
      selectPeopleStore.companyCode = value
    },
    [selectPeopleStore]
  )

  const handleSubmit = useCallback(() => {
    if (props.setIsSelectUser) {
      props.setIsSelectUser(true)
    }
    handleSubmitSelectUser()
    setDefaultActiveKey([])
    if (checkSelectOne) {
      setCheckSelectOne(false)
    }
  }, [
    props.setIsSelectUser,
    handleSubmitSelectUser,
    checkSelectOne,
    setCheckSelectOne,
  ])

  const handleClearAll = useCallback(() => {
    if (ignoreSelectList.length > 0 && assigneePopupType) {
      const bdhUsers = (selectUserData[assigneePopupType] || []).filter(el =>
        isIgnoreSelect(ignoreSelectList, el)
      )
      selectPeopleStore.setSelectUserData({
        ...selectUserData,
        [assigneePopupType]: bdhUsers,
      })
      handleUpdateEmpty()
      return
    }
    selectPeopleStore.setSelectUserData({
      ...selectUserData,
      [assigneePopupType]: [],
    })
    handleUpdateEmpty()
  }, [
    selectPeopleStore,
    selectUserData,
    assigneePopupType,
    handleUpdateEmpty,
    ignoreSelectList,
  ])

  const handleClearAllUserDepartment = useCallback(() => {
    if (ignoreSelectList.length > 0 && assigneePopupType) {
      const banDieuHanhDepts = (
        selectDepartmentData[assigneePopupType] || []
      ).filter(el => isIgnoreSelect(ignoreSelectList, el))
      const banDieuHanhUsers = (
        selectUserData[assigneePopupType] || []
      ).filter(el => isIgnoreSelect(ignoreSelectList, el))
      selectPeopleStore.setSelectUserData({
        ...selectUserData,
        [assigneePopupType]: banDieuHanhUsers,
      })
      selectPeopleStore.setSelectDepartmentData({
        ...selectDepartmentData,
        [assigneePopupType]: banDieuHanhDepts,
      })
      return
    }
    selectPeopleStore.handleRemoveSelectUserDepartment()
  }, [
    ignoreSelectList,
    selectPeopleStore,
    selectDepartmentData,
    selectUserData,
    assigneePopupType,
  ])

  const handleOkClick = useCallback(() => {
    JSON.stringify(selectDepartmentData[assigneePopupType]) !==
      JSON.stringify(prevDepartmentList) ||
    JSON.stringify(selectUserData[assigneePopupType]) !==
      JSON.stringify(prevUserList)
      ? handleSubmit()
      : handleCancelSelectUser()
  }, [
    selectDepartmentData,
    assigneePopupType,
    prevDepartmentList,
    selectUserData,
    prevUserList,
    handleSubmit,
    handleCancelSelectUser,
  ])

  const handleCloseClick = useCallback(() => {
    if (checkSelectOne) {
      setCheckSelectOne(false)
    }
    setSelectUserData({
      ...selectUserData,
      [assigneePopupType]: prevUserList,
    })
    setSelectDepartmentData({
      ...selectDepartmentData,
      [assigneePopupType]: prevDepartmentList,
    })
    handleCancelSelectUser()
  }, [
    checkSelectOne,
    setCheckSelectOne,
    selectUserData,
    assigneePopupType,
    prevUserList,
    setSelectUserData,
    selectDepartmentData,
    prevDepartmentList,
    setSelectDepartmentData,
    handleCancelSelectUser,
  ])

  const companyOptions = useMemo(() => {
    return companyList?.map(item => (
      <Option key={item.code} value={item.code}>
        {item.name}
      </Option>
    ))
  }, [companyList])

  const titleContent = useMemo(() => {
    return (
      <div className="assign-member-modal-title-container">
        <div>
          {showDropdownCompany ? (
            <Select
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              className="h-40"
              style={{ width: '100%' }}
              onChange={onCompanyChange}
              value={
                companyCode || authenticationStore?.currentUser?.company?.code
              }
              notFoundContent={<EmptyContent />}
              placeholder={'Chọn công ty'}>
              {companyOptions}
            </Select>
          ) : (
            <span>{title || selectPopupName}</span>
          )}
        </div>
        <div className="group-btn-action">
          {disableSelectDepartment || cancelText ? (
            <Popconfirm
              placement="top"
              title={'Bạn có chắc chắn muốn xóa hết người được chọn không ?'}
              onConfirm={handleClearAll}
              okText="Đồng ý"
              cancelText="Không"
              zIndex={1600}>
              <Button danger className="custom-ant-button">
                {cancelText || 'Hủy chọn'}
              </Button>
            </Popconfirm>
          ) : (
            <Popconfirm
              zIndex={2000}
              placement="top"
              title={'Bạn có chắc chắn muốn xóa hết người được chọn không ?'}
              onConfirm={handleClearAllUserDepartment}
              okText="Đồng ý"
              cancelText="Không">
              <Button danger className="custom-ant-button">
                {cancelText || 'Hủy chọn'}
              </Button>
            </Popconfirm>
          )}
          <Button
            type={'primary'}
            onClick={handleOkClick}
            className="custom-ant-button">
            {okText || 'Đồng ý'}
          </Button>
          <CloseOutlined
            onClick={handleCloseClick}
            style={{
              width: 24,
              height: 24,
            }}
          />
        </div>
      </div>
    )
  }, [
    showDropdownCompany,
    onCompanyChange,
    companyCode,
    authenticationStore?.currentUser?.company?.code,
    companyOptions,
    title,
    selectPopupName,
    disableSelectDepartment,
    cancelText,
    handleClearAll,
    handleClearAllUserDepartment,
    okText,
    handleOkClick,
    handleCloseClick,
  ])

  const selectedListContent = useMemo(() => {
    return selectedList.length > 0 ? (
      selectedList.map(el => {
        const isIgnore =
          el.assignee_type === ignorePopupType &&
          isIgnoreSelect(ignoreSelectList, el)
        const isClosable = !(isIgnore && ignoreSelectList.length > 0)
        return (
          <Tag
            className={'tag-selected'}
            color={'blue'}
            key={el.id}
            closable={isClosable}
            onClose={() => handleRemoveSelect(el)}>
            <AvatarHasName
              imgId={el.image_id}
              size={22}
              name={el.full_name}
              icon={
                el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                  <BankOutlined />
                )
              }
            />
          </Tag>
        )
      })
    ) : (
      <Empty style={{ width: '100%' }} image={Empty.PRESENTED_IMAGE_SIMPLE} />
    )
  }, [selectedList, handleRemoveSelect, ignoreSelectList])

  return (
    <Modal
      maskClosable={false}
      okText={okText || 'Đồng ý'}
      cancelText={'Hủy bỏ'}
      width={950}
      style={{ top: 20 }}
      zIndex={1000}
      title={titleContent}
      closable={false}
      forceRender={true}
      footer={null}
      visible={isVisibleSelectPeoplePopup}
      wrapClassName="custom-modal-wrapper assign-member-modal">
      <div className="assign-member-modal-left-box">
        <div className="assign-member-modal-left-content">
          <SelectUserDepartmentBox
            defaultKeys={defaultKeys}
            defaultActiveKey={defaultActiveKey}
            setDefaultActiveKey={setDefaultActiveKey}
            isOpenCollapse={isOpenCollapse}
            isVisibleSelectPeoplePopup={isVisibleSelectPeoplePopup}
            disableSelectDepartment={disableSelectDepartment}
            onlyOneUser={
              assigneePopupType === 'ban_kt_ktnb_vimc' ||
              assigneePopupType === 'ban_dieu_hanh' ||
              assigneePopupType === 'hdqt_vimc'
                ? !onlyOneUser
                : onlyOneUser
            }
            onlySelectOne={onlySelectOne}
            userDisableList={userDisableList}
            departmentDisableList={departmentDisableList}
            departmentType={departmentType}
            ignoreSelectList={ignoreSelectList}
            ignorePopupType={ignorePopupType}
          />
          <SpinnerInlineComponent
            sizeSpin={'small'}
            isLoading={isLoading}
            noBackground
          />
        </div>
      </div>
      <div className="assign-member-modal-right-box">
        <div
          style={{
            marginBottom: '16px',
            fontWeight: 500,
          }}>
          Danh sách đã chọn:
        </div>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 8,
          }}>
          {selectedListContent}
        </div>
      </div>
    </Modal>
  )
}

SelectPeoplePopup.propTypes = {}

export default memo(
  inject(
    'selectPeopleStore',
    'companyStore',
    'authenticationStore'
  )(observer(SelectPeoplePopup))
)
